import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop(props) {
    const location = useLocation();

    useEffect(
        function () {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        },
        [location.pathname],
    );

    return <>{props.children}</>;
}
